<!-- @format -->
<template>
    <div>
        <p class="na-sidebar-copyright-text">Copyright &copy; {{ year }}. Electric Valley Media, LLC</p>
        <p class="na-sidebar-copyright-text">All rights reserved</p>
    </div>
</template>

<script>
export default {
    props: {
        year: {
            type: String,
            default: ''
        }
    }
};
</script>
